import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, ConfigProvider, Radio, Result, notification, Card, Row, Col, Alert, Checkbox, Space } from 'antd';
import 'dayjs/locale/es';
import { ClockCircleFilled, CloseCircleOutlined } from '@ant-design/icons';
import { Link, useSearchParams } from 'react-router-dom';
import changeHeight from '../../data/changeHeight';
import axios from 'axios';



const SegundaOportunidadBlog = () => {
    const [step, setStep] = useState(0);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [userData, setUserData] = useState({});
    const [primaryColor, setPrimaryColor] = useState('#FFFFFF');
    const [searchParams] = useSearchParams();
    const [form] = Form.useForm();
    const refForm = useRef(0);
    const refResult = useRef(0);
    const [resultError, setResultError] = useState("none");
    const [result, setResult] = useState("none");
    const [heightResult, setHeightResult] = useState(0);
    const [api, contextHolder] = notification.useNotification();
    const [alertDeudas, setAlertDeudas] = useState(false);
    const [isValidated, setIsValidated] = useState(false);
    const [isEligible, setIsEligible] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');
    const [validationVisible, setValidationVisible] = useState(false);

    useEffect(() => {
        if (searchParams.get("primaryColor")) {
            setPrimaryColor('#' + searchParams.get("primaryColor"));
            setHeightResult(refResult.current.clientHeight);
            changeHeight(refForm.current.clientHeight);
            setResultError("none");
            setResult("none");
        }
        if (searchParams.get("parentUrl")) {
            form.setFieldsValue({ url: searchParams.get("parentUrl") });
        }
    }, [searchParams]);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.target === refForm.current) {
                    changeHeight(entry.target.clientHeight);
                    break;
                }
            }
        });

        resizeObserver.observe(refForm.current);

        return () => {
            resizeObserver.unobserve(refForm.current);
        };
    }, []);

    window.addEventListener('message', (event) => {
        if (event.data.type === "from-parent") {
            if (event.data.fbp === 'null' || event.data.fbp === null || event.data.fbp === undefined) {
                form.setFieldsValue({ fbp: " " });
            } else {
                form.setFieldsValue({ fbp: event.data.fbp });
            }
            if (event.data.hubspotutk === 'null' || event.data.hubspotutk === null || event.data.hubspotutk === undefined) {
                form.setFieldsValue({ hubspotutk: " " });
            } else {
                form.setFieldsValue({ hubspotutk: event.data.hubspotutk });
            }
            if (event.data.userAgent) { form.setFieldsValue({ userAgent: event.data.userAgent }); }
            changeHeight(refForm.current.clientHeight);
        }
    });

    // Función para validar elegibilidad
    const validateEligibility = (values) => {

        // Criterios de descalificación
        let reasons = [];

        if (values.esPersonaFisica === false) {
            reasons.push("Solo personas físicas pueden acogerse a la Ley de Segunda Oportunidad, no empresas.");
        }

        if (values.deudas === false) {
            reasons.push("Es necesario tener deudas con al menos dos acreedores diferentes.");
        }

        if (values.insolvencia === false) {
            reasons.push("Debe encontrarse en situación de insolvencia actual o inminente para acogerse a la ley.");
        }

        if (values.usoPrevio === true) {
            reasons.push("No puede acogerse a la Ley de Segunda Oportunidad si ya la ha utilizado en los últimos 5 años.");
        }

        if (values.condenaDelitos === true) {
            reasons.push("No puede acogerse si ha sido condenado por delitos socioeconómicos en los últimos 10 años.");
        }

        if (values.deudaExcesiva === true) {
            reasons.push("La suma total de sus deudas no puede superar los 5,000,000 euros.");
        }

        if (values.transferenciaFraudulenta === true) {
            reasons.push("No puede acogerse si ha transferido bienes a terceros para evitar pagar deudas.");
        }

        if (values.residenciaEspana === false) {
            reasons.push("Debe residir en España o tener su centro de intereses principal en el país.");
        }

        if (values.deudasRecientes === true) {
            reasons.push("No puede acogerse si ha contraído nuevas deudas en el último año sabiendo que no podía pagarlas.");
        }

        if (values.ocultacionActivos === true) {
            reasons.push("No puede acogerse si ha ocultado o no declarado algún activo o propiedad.");
        }

        setIsValidated(true);

        if (reasons.length > 0) {
            setValidationMessage(
                <Card
                    title="Formulario ley de segunda oportunidad"
                    style={{ width: '100%', backgroundColor: "#f0f2f5" }}
                    headStyle={{
                        backgroundColor: primaryColor,
                        color: "white"
                    }}
                >
                    <Alert
                        message="No Cumple con los Requisitos"
                        description={
                            <div>
                                <p style={{ marginBottom: '12px' }}>Lo sentimos, pero no cumple con los requisitos para acogerse a la Ley de Segunda Oportunidad por las siguientes razones:</p>
                                {reasons.map((reason, index) => (
                                    <p key={index} style={{ marginBottom: '8px' }}>
                                        {index + 1}. {reason}
                                    </p>
                                ))}
                            </div>
                        }
                        type="error"
                        showIcon
                        style={{ marginBottom: "20px" }}
                    />
                    <Alert
                        message="¿Necesitas una revisión profesional?"
                        description={
                            <p>
                                Si deseas que nuestros profesionales revisen tu caso específico,
                                escríbenos a <a href="mailto:hola@coventia.es">hola@coventia.es</a>
                            </p>
                        }
                        type="success"
                        showIcon
                        style={{ marginTop: '20px' }}
                    />
                    <div ref={refResult} style={{ padding: '1rem' }}>
                        <Result
                            icon={<ClockCircleFilled  style={{ color: primaryColor }} />}
                            style={{ padding: '1.5rem', paddingTop: '3rem' }}
                            status="success"
                            title="¿Concertar una cita?"
                            subTitle={<span dangerouslySetInnerHTML={{ __html: subtitleText }} />}
                            extra={[
                                <Button type="primary" key="console" target='_blank' href='https://meetings-eu1.hubspot.com/francisco-cano-fernandez'>
                                    Haz clic para concertar una cita
                                </Button>
                            ]}
                        />
                    </div>
                </Card>
            );
            setIsEligible(false);
        } else {
            setValidationMessage(
                <Card   
                    title="Formulario ley de segunda oportunidad"
                    style={{ width: '100%', backgroundColor: "#f0f2f5" }}
                    headStyle={{
                        backgroundColor: primaryColor,
                        color: "white"
                    }}
                >
                    <Alert
                        message="Validación Exitosa"
                        description={
                            <div>
                                <p>¡Felicidades! Basado en sus respuestas, cumple con los requisitos para acogerse a la Ley de Segunda Oportunidad.</p>
                                <p>
                                    Si deseas que nuestros profesionales revisen tu caso específico,
                                    escríbenos a <a href="mailto:hola@coventia.es">hola@coventia.es</a>
                                </p>
                            </div>

                        }
                        type="success"
                        showIcon
                        style={{ marginBottom: "20px" }}
                    />
                    <div ref={refResult} style={{ padding: '1rem' }}>
                        <Result
                            icon={<ClockCircleFilled style={{ color: primaryColor }} />}
                            style={{ padding: '1.5rem', paddingTop: '3rem' }}
                            status="success"
                            title="¿Concertar una cita?"
                            subTitle={<span dangerouslySetInnerHTML={{ __html: subtitleText }} />}
                            extra={[
                                <Button type="primary" key="console" target='_blank' href='https://meetings-eu1.hubspot.com/francisco-cano-fernandez'>
                                    Haz clic para concertar una cita
                                </Button>
                            ]}
                        />
                    </div>
                </Card>
            );
            setIsEligible(true);
        }

        setStep(1);
        setValidationVisible(true);

        // Añadir un pequeño delay para asegurar que el DOM se ha actualizado
        setTimeout(() => {
            const validationDiv = document.querySelector('.validation-results');
            if (validationDiv) {
                changeHeight(validationDiv.clientHeight);
            }
        }, 100);

        // Llamada al Lambda en lugar de Baserow directamente
        axios({
            method: "POST",
            url: "https://bo642f5ow33x6a4nh5r7qndbci0pzajk.lambda-url.eu-west-3.on.aws/", // Reemplazar con la URL de tu Lambda
            headers: {
                "Content-Type": "application/json"
            },
            data: {
                ...values,
                ingresosMensuales: values.ingresosMensuales ? values.ingresosMensuales.replace(',', '.') : undefined,
                gastosDeudasMensuales: values.gastosDeudasMensuales ? values.gastosDeudasMensuales.replace(',', '.') : undefined
            }
        })
    };


    const subtitleText = "Si lo prefieres, haz clic para programar una cita en la fecha de tu elección.";

    const onChangeDeudas = (value) => {
        if (value === false) {
            setAlertDeudas(true);
        } else {
            setAlertDeudas(false);
        }
    };

    // Función helper para simular diferentes escenarios
    // const simulateValidation = (isEligible) => {
    //     const mockValues = {
    //         email: 'test@test.com',
    //         tel: '666666666',
    //         esPersonaFisica: isEligible,
    //         deudas: true,
    //         insolvencia: true,
    //         usoPrevio: !isEligible,
    //         condenaDelitos: false,
    //         deudaExcesiva: false,
    //         transferenciaFraudulenta: false,
    //         residenciaEspana: true,
    //         deudasRecientes: false,
    //         ocultacionActivos: false,
    //         garantiasReales: false,
    //         deudasEspeciales: false,
    //         deudasPublicas: false
    //     };
    //     validateEligibility(mockValues);
    // };

    return (
        <>
            {contextHolder}
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: primaryColor,
                    },
                }}
            >
                {/* DEBUG: Añadir panel de desarrollo cuando el step sea 0 */}
                {/* {step === 0 && (
                    <Card style={{ marginBottom: '1rem', background: '#f0f0f0' }}>
                        <h4>Panel de Desarrollo</h4>
                        <Space>
                            <Button onClick={() => setStep(0)}>
                                Ir a Formulario (Step 0)
                            </Button>
                            <Button onClick={() => simulateValidation(true)}>
                                Simular Validación Exitosa
                            </Button>
                            <Button onClick={() => simulateValidation(false)}>
                                Simular Validación Fallida
                            </Button>
                        </Space>
                    </Card>
                )} */}

                <style>
                    {`
                    ::-webkit-scrollbar {
                        display: none;
                    }
                    `}
                </style>
                <div ref={refForm} style={step === 0 ? { display: 'block' } : { display: 'none' }}>
                    <Card 
                        title="Formulario ley de segunda oportunidad"
                        style={{ width: '100%', backgroundColor: "#f0f2f5" }}
                        headStyle={{
                            backgroundColor: primaryColor,
                            color: "white"
                        }}
                    >
                        <Form
                            form={form}
                            style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}
                            hidden={success}
                            name="basic"
                            initialValues={{ remember: true }}
                            layout='vertical'
                            onFinish={validateEligibility}
                        >
                            {/* Form items */}
                            <Form.Item
                                hidden={true}
                                label="URL"
                                name="url"
                            >
                                <Input type='text' />
                            </Form.Item>

                            <Form.Item
                                hidden={true}
                                label="FB"
                                name="fbp">
                                <Input type='' />
                            </Form.Item>

                            <Form.Item
                                hidden={true}
                                label="Hubspotutk"
                                name="hubspotutk">
                                <Input type='' />
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Es usted una persona física (no una empresa)?</p>}
                                name="esPersonaFisica"
                                rules={[{ required: true, message: 'Por favor, selecciona una opción' }]}
                            >
                                <Radio.Group style={{ paddingLeft: "10px" }} disabled={buttonLoading}>
                                    <Radio value={true}>Sí</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Tiene deudas con dos o más entidades diferentes (bancos, financieras...)?</p>}
                                name="deudas"
                                rules={[{ required: true, message: 'Por favor, selecciona una opción' }]}
                            >
                                <Radio.Group
                                    style={{ paddingLeft: "10px" }}
                                    disabled={buttonLoading}
                                    onChange={(e) => onChangeDeudas(e.target.value)}
                                >
                                    <Radio value={true}>Sí</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            {alertDeudas && (
                                <Alert
                                    message="Requisito importante"
                                    description="Tener deudas con al menos dos acreedores diferentes es un requisito para acogerse a la Ley de Segunda Oportunidad, pero puede continuar completando el formulario para recibir una evaluación completa."
                                    type="warning"
                                    showIcon
                                    style={{ marginBottom: "20px" }}
                                />
                            )}

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Ha usado la Ley de Segunda Oportunidad en los últimos 5 años?</p>}
                                name="usoPrevio"
                                rules={[{ required: true, message: 'Por favor, selecciona una opción' }]}
                            >
                                <Radio.Group style={{ paddingLeft: "10px" }} disabled={buttonLoading}>
                                    <Radio value={true}>Sí</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Ha sido condenado por delitos socioeconómicos en los últimos 10 años?</p>}
                                name="condenaDelitos"
                                rules={[{ required: true, message: 'Por favor, selecciona una opción' }]}
                            >
                                <Radio.Group style={{ paddingLeft: "10px" }} disabled={buttonLoading}>
                                    <Radio value={true}>Sí</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿La suma total de sus deudas es mayor a 5,000,000 euros?</p>}
                                name="deudaExcesiva"
                                rules={[{ required: true, message: 'Por favor, selecciona una opción' }]}
                            >
                                <Radio.Group style={{ paddingLeft: "10px" }} disabled={buttonLoading}>
                                    <Radio value={true}>Sí</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Ha transferido bienes o propiedades a terceros para evitar pagar deudas?</p>}
                                name="transferenciaFraudulenta"
                                rules={[{ required: true, message: 'Por favor, selecciona una opción' }]}
                            >
                                <Radio.Group style={{ paddingLeft: "10px" }} disabled={buttonLoading}>
                                    <Radio value={true}>Sí</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Reside en España o tiene su centro de intereses principal en el país?</p>}
                                name="residenciaEspana"
                                rules={[{ required: true, message: 'Por favor, selecciona una opción' }]}
                            >
                                <Radio.Group style={{ paddingLeft: "10px" }} disabled={buttonLoading}>
                                    <Radio value={true}>Sí</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Ha contraído nuevas deudas en el último año sabiendo que no podía pagarlas?</p>}
                                name="deudasRecientes"
                                rules={[{ required: true, message: 'Por favor, selecciona una opción' }]}
                            >
                                <Radio.Group style={{ paddingLeft: "10px" }} disabled={buttonLoading}>
                                    <Radio value={true}>Sí</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Ha ocultado o no declarado algún activo o propiedad?</p>}
                                name="ocultacionActivos"
                                rules={[{ required: true, message: 'Por favor, selecciona una opción' }]}
                            >
                                <Radio.Group style={{ paddingLeft: "10px" }} disabled={buttonLoading}>
                                    <Radio value={true}>Sí</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Tiene deudas aseguradas por garantías reales, como hipotecas o prendas?</p>}
                                name="garantiasReales"
                                rules={[{ required: true, message: 'Por favor, selecciona una opción' }]}
                            >
                                <Radio.Group style={{ paddingLeft: "10px" }} disabled={buttonLoading}>
                                    <Radio value={true}>Sí</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Tiene deudas por costos judiciales, pensiones alimentarias o responsabilidades civiles?</p>}
                                name="deudasEspeciales"
                                rules={[{ required: true, message: 'Por favor, selecciona una opción' }]}
                            >
                                <Radio.Group style={{ paddingLeft: "10px" }} disabled={buttonLoading}>
                                    <Radio value={true}>Sí</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Tiene deudas con administraciones públicas como Hacienda o Seguridad Social?</p>}
                                name="deudasPublicas"
                                rules={[{ required: true, message: 'Por favor, selecciona una opción' }]}
                            >
                                <Radio.Group style={{ paddingLeft: "10px" }} disabled={buttonLoading}>
                                    <Radio value={true}>Sí</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Cuáles son sus ingresos mensuales aproximados? (en euros)</p>}
                                name="ingresosMensuales"
                                rules={[{ required: true, message: 'Por favor, ingresa tus ingresos mensuales' }, { pattern: /^\d+(,\d{1,2})?$/, message: 'Solo se permiten números, puedes usar coma para decimales' }]}
                            >
                                <Input placeholder="Ejemplo: 1200,54" type="text" disabled={buttonLoading} />
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Cuánto pagas mensualmente en préstamos o deudas? (en euros)</p>}
                                name="gastosDeudasMensuales"
                                rules={[{ required: true, message: 'Por favor, ingresa el total mensual de pagos de deudas' }, { pattern: /^\d+(,\d{1,2})?$/, message: 'Solo se permiten números, puedes usar coma para decimales' }]}
                            >
                                <Input placeholder="Ejemplo: 800,00" type="text" disabled={buttonLoading} />
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Dónde te podemos enviar un email?</p>}
                                name="email"
                                rules={[{ required: true, message: 'Por favor, ingresa tu email' }]}
                            >
                                <Input placeholder='tunombre@email.com' type='email' disabled={buttonLoading} />
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "0.6rem" }}
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Dónde podemos llamarte?</p>}
                                name="tel"
                                rules={[{ required: true, message: 'Por favor, ingresa tu teléfono' }]}
                            >
                                <Input placeholder='919 99 31 31' type='tel' disabled={buttonLoading} maxLength={9} minLength={9} />
                            </Form.Item>

                            {validationVisible && (
                                <div style={{ padding: '1rem' }}>
                                    {validationMessage}
                                </div>
                            )}

                            <Form.Item
                                style={{ marginBottom: "0rem" }}
                                valuePropName="checked"
                                name="terms"
                                initialValue={false}
                                rules={[{
                                    required: true,
                                    validator: async (_, checked) => {
                                        if (!checked) {
                                            return Promise.reject(new Error("Por favor, acepta los términos y condiciones"));
                                        }
                                    }
                                }]}
                            >
                                <Checkbox style={{ fontSize: "15px" }} disabled={buttonLoading}>
                                    Acepto los <Link target='_blank' to='https://www.coventia.es/politica-de-privacidad-y-aviso-de-cookies'>términos y condiciones</Link>
                                </Checkbox>
                            </Form.Item>

                            <Button
                                type='primary'
                                loading={buttonLoading}
                                htmlType='submit'
                                style={{ width: "100%", height: "35px", marginTop: 20 }}
                            >
                                {buttonLoading ? 'Procesando...' : isValidated ? (isEligible ? 'Enviar' : 'Validar de nuevo') : 'Validar'}
                            </Button>
                        </Form>
                    </Card>
                </div>

                {step === 1 && (
                    <div className="validation-results" style={{ padding: '1rem' }}>
                        {validationMessage}
                    </div>
                )}

                <div ref={refResult} style={{ display: resultError, padding: 50 }}>
                    <Card style={{ width: '80%', margin: 'auto' }}>
                        <Row>
                            <Col span={24}>
                                <h1 style={{ textAlign: 'start' }}>Lo sentimos</h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <p style={{ fontSize: 16 }}>
                                    Lamentamos informarte que, por el momento, no cumples con los requisitos necesarios para acogerte a la Ley de Segunda Oportunidad.
                                </p>
                                <p style={{ fontSize: 16 }}>
                                    Uno de los criterios fundamentales es encontrarte en una situación de insolvencia, ya sea actual o inminente.
                                </p>
                                <p style={{ fontSize: 16 }}>
                                    ¿A qué nos referimos? Si la insolvencia es "actual", significa que ya no puedes hacer frente a tus deudas. Si es "inminente", implica que en los próximos 3 meses no podrás asumir esos pagos.
                                </p>
                                <p style={{ fontSize: 16 }}>
                                    Gracias por confiar en nosotros y esperamos poder ayudarte en un futuro.
                                </p>
                            </Col>
                        </Row>
                    </Card>
                </div>
            </ConfigProvider>
        </>
    );
};

export default SegundaOportunidadBlog;